<template>
  <div :class="{'op--modal-container':true, 'hide': !preview}" @click="close">
    <div class="op--modal">
      <div class="op--modal-content preview-box" @click.stop>
        <div class="preview web">
          <div class="label">Web</div>
          <preview-web :details="details"></preview-web>
        </div>
        <div class="preview">
          <div class="label">Web - Mobile</div>
          <preview-mobile :details="details"></preview-mobile>
        </div>
        <div class="preview">
          <div class="label">Consumer App</div>
          <preview-consumer :details="details"></preview-consumer>
        </div>

        <div class="fixed-bottom">
          <div>
            <a class="button cta small" @click="close">
                <i class="fas fa-ban"></i> Close Preview
              </a>
          </div>
        </div>
      </div>
    </div>
  </div> 
</template>

<script>
// import moment from 'moment'
import previewWeb from './PreviewWeb'
import previewMobile from './PreviewMobile'
import previewConsumer from './PreviewConsumer'

export default {
  name: 'preview',
  components: {previewWeb, previewMobile, previewConsumer},
  data () {
    return {}
  },
  computed: {
    preview () { return this.$store.state.services.preview },
    details () { return this.$store.state.services.details }
  },
  methods: {
    close () {
      this.$store.commit('services/setPreview', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.op--modal-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.op--modal {
  display: table;
  width: 100%;
  height: 100%;
}
.op--modal-content.center{
  display: table-cell;
  vertical-align: middle;
}

.preview-box{
  background-color: #fff;
  border-radius: 4px;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  position: relative;
  padding: 20px;
}

.preview{
  text-align: center;
  margin-bottom: 40px;

  .label{
    font-size:21px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
    text-align: left;
  }
}

.fixed-bottom {
  display: none;
}

@media only screen and (max-width: 430px) {
  .preview-box {
    width: 100%;
    padding: 20px 0;
    padding-bottom: 100px;

    .web {
      display: none;
    }

    .preview {
      padding: 0 10px;
    }
  }

  .fixed-bottom {
    display: block;
    width: 100%;
    padding: 10px 0;
    position: fixed;
    bottom: 0;
    background: #fff;
    border-top: 1px solid #b0c6e4;
    text-align: center;
    box-shadow: 0 -2px 3px rgba(0,0,0, .1);
    z-index: 3;

    .button{
      text-transform: uppercase;
      margin: 0 5px;
      min-width: 160px;
      i{ margin-right: 7px; }
    }
  }

  .hide {
    .fixed-bottom {
      display: none;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Services/Preview.vue